module.exports = __webpack_public_path__ + "f5020d390bfde8343ca79653899cd130.svg";